import { render, staticRenderFns } from "./DeckBuilder.vue?vue&type=template&id=72d2ca92&"
import script from "./DeckBuilder.vue?vue&type=script&lang=js&"
export * from "./DeckBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports